<template>
  <print v-if="isPrint" :value="form" :header="header" :board="board"/>
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :visible-field-form="false"
    />

    <!--    점검시설정보-->
    <div class="mb-4">
      <div>
        <h5><i class="dot"></i>점검시설정보</h5>
      </div>
    </div>
    <div class="">
      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>시설명</div>
          <div class="flex flex-1 items-center">
            <div v-if="isPrint" class="print-textarea">{{form.fields.join(',')}}</div>
            <field-selector class="w-full" multiple v-model="form.fields" @select="selectFields"></field-selector>
          </div>
        </div>
        <div class="writeGridCol2">
          <div>소관부서</div>
          <span class="print-input"> {{소관부서}} </span>
        </div>
      </div>

      <div class="writeGridContainer">
        <div class="col-span-6">
          <div>점검기간</div>
          <span v-if="isPrint" class="print-input"> {{form.점검기간.sDate}} - {{form.점검기간.eDate}} </span>
          <div v-else class="flex flex-1 items-center">
            <date-selector-rang v-model="form.점검기간" :readonly="board.readonly"/>
          </div>
        </div>
      </div>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <span>점검내용</span>
          <span v-if="isPrint" class="print-input"> {{ form.점검내용 }} </span>
          <ml-input v-else v-model="form.점검내용" :readonly="board.readonly" placeholder="중대재해처벌법 시행에 따른 안전관리 의무이행 사항 자체점검"/>
        </div>
        <div class="writeGridLineItem">
          <span>총평</span>
          <span v-if="isPrint" class="print-input"> {{ form.총평 }} </span>
          <ml-input v-else v-model="form.총평" :readonly="board.readonly" placeholder="전반적인 안전관리 사항, 이행점검 시 중요사항 및 애로사항 중심으로 기재"/>
        </div>
      </div>
    </div>

    <!--    시설개요-->
    <div class="mt-28px">
      <div class="flex items-center mb-4">
        <h5><i class="dot"></i>시설개요</h5>
        <span class="ml-auto" style="color: #7E72F2;">※ ⑥, ⑦번 항목은 위탁시설만 기재</span>
      </div>
      <div class="overflow-y-auto" style="position: relative; max-height: 620px;">
        <table cellspacing="0" style="border-spacing: 0;">
          <thead style="position:sticky; top: 0; z-index:10; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);">
          <tr>
            <th>No.</th>
            <th>①시설명</th>
            <th>②주소</th>
            <th>③규모</th>
            <th>④대상법령</th>
            <th>⑤시설종류</th>
            <th>⑥관리형태</th>
            <th>⑥위탁시설-위탁부서</th>
            <th>⑥위탁시설-위탁기간</th>
            <th>⑦수탁현황-기관명</th>
            <th>⑦수탁현황-수탁비용</th>
            <th>수정/삭제</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(field, index) in form.fields">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">{{ field.field_name }}</td>
            <td class="text-center">{{ field.address }}</td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <ml-input v-model="editData.규모" class="w-full text-left" placeholder="연면적"/>
              </template>
              <template v-else>
                {{ field.규모 }}
              </template>
            </td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <ml-input v-model="editData.대상법령" class="w-full text-left" placeholder="실내공기질관리법 (시설물 안전법 1,2,3종)"/>
              </template>
              <template v-else>
                {{ field.대상법령 }}
              </template>
            </td>
            <td class="text-center">{{ field.시설종류 }}</td>
            <td class="text-center">{{ field.관리형태 }}</td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <ml-input v-model="editData.위탁부서" class="w-full text-left" placeholder="입력" />
              </template>
              <template v-else>
                {{ field.위탁부서 }}
              </template>
            </td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <date-selector-rang v-model="editData.위탁기간" class="w-full" />
              </template>
              <template v-else>
                {{ field.위탁기간 && `${field.위탁기간.sDate} ~ ${field.위탁기간.eDate}` }}
              </template>
            </td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <ml-input v-model="editData.수탁기관명" class="w-full text-left" placeholder="입력"/>
              </template>
              <template v-else>
                {{ field.수탁기관명 }}
              </template>
            </td>
            <td class="text-center">
              <template v-if="editIndex === index">
                <ml-input v-model="editData.수탁비용" class="w-full text-left" placeholder="00백만원/독립채산제"/>
              </template>
              <template v-else>
                {{ field.수탁비용 }}
              </template>
            </td>
            <td class="text-center">
              <div class="icon-buttons flex justify-center gap-3">
                <fragment v-if="editIndex === index">
                  <button @click="onClickFinishData(index)">
                    <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickCancelData(index)">
                    <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
                <fragment v-else>
                  <button @click="onClickEditData(index)">
                    <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickRemoveData(index)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- 구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 구분</h5>

      <div class="grid grid-cols-6">
        <radio-group v-model="form.구분" flex :items="['상반기', '하반기']" />
      </div>
    </div>

    <!--    안전관리 추진현황-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 안전관리 추진현황</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
      <div v-for="_title in type1Title" :key="`checkbox_type1_${_title}`" class="col-span-1 flex items-center">
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div v-if="form.type1Checked.includes(_title)" style="background: #200c63"
               class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ _title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.type1Checked" :vs-value="_title">{{ _title
              }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <!--    관리개선 및 보완사항-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 관리개선 및 보완사항</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
      <div v-for="_title in type2Title" :key="`checkbox_type2_${_title}`" class="col-span-1 flex items-center">
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div v-if="form.type2Checked.includes(_title)" style="background: #200c63"
               class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ _title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.type2Checked" :vs-value="_title">{{ _title
              }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <!-- 의무이행사항 점검결과 -->
<!--    <div class="mt-28px">-->
<!--      <h5 class="mb-4"><i class="dot"></i> 의무이행사항 점검결과</h5>-->
<!--      <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">-->
<!--        <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_inspect_${_title}`"-->
<!--             class="col-span-1 flex items-center">-->
<!--          <div v-if="isPrint || board.readonly" class="flex items-center">-->
<!--            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63"-->
<!--                 class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">-->
<!--              <vs-icon icon="check" size="x-small"></vs-icon>-->
<!--            </div>-->
<!--            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>-->
<!--            <span class="flex-1">-->
<!--              {{ _title }}-->
<!--            </span>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <span class="flex">-->
<!--              <vs-checkbox v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 안전예산 집행내역 -->
    <div class="mt-28px" v-show="form.type1Checked.includes('안전예산 집행내역')">
      <div class="flex justify-between">
        <h5 class="mb-4"><i class="dot"></i>안전예산 집행내역</h5>
        <span>[단위: 천원]</span>
      </div>
      <table class="mb-4">
        <thead>
        <tr>
          <th>구분</th>
          <th>편성액</th>
          <th>집행액</th>
          <th>잔액</th>
          <th>추가소요액</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(value, key) in form.집행내역" :key="`집행내역_${key}`">
          <th>{{ key }}</th>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ value.편성액 }} </span>
              <comma-input v-else :readonly="board.readonly" v-model="value.편성액"
                           @input="inputNumber(key)" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ value.집행액 }} </span>
              <comma-input v-else :readonly="board.readonly" v-model="value.집행액"
                           @input="inputNumber(key)" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ value.잔액 }} </span>
              <comma-input v-else readonly :value="value.잔액" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ value.추가소요액 }} </span>
              <comma-input v-else :readonly="board.readonly" v-model="value.추가소요액"
                           @input="inputNumber(key)" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
        </tr>
        <tr>
          <th>합계</th>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ form.합계.편성액 }} </span>
              <comma-input v-else readonly :value="form.합계.편성액" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ form.합계.집행액 }} </span>
              <comma-input v-else readonly :value="form.합계.집행액" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ form.합계.잔액 }} </span>
              <comma-input v-else readonly :value="form.합계.잔액" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <span v-if="isPrint" class="print-input"> {{ form.합계.추가소요액 }} </span>
              <comma-input v-else readonly :value="form.합계.추가소요액" class="w-full text-right" />
              <span class="whitespace-no-wrap">천원</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div style="font-size: 14px; font-weight: 400; color: #7e72f2" class="mb-4">
        * 직접관리 시설은 안전관리를 위해 채용한 기간제, 일시사역 인력(공무원·공무직인건비 제외)의 인건비만 기재, 위탁관리 시설은 안전관리 전체 인원의 인건비 기재<br />
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="textarea-label p-0">추가 소요액 확보계획</div>
          <span v-if="isPrint" class="print-input"> {{ form.추가소요액확보계획 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.추가소요액확보계획"
                    placeholder="안전점검 추가소요액 2025년 당초예산, 추경예산으로 확보" />
        </div>
      </div>
    </div>

    <div v-show="form.type1Checked.includes('안전인력 운용현황')">
      <h5 class="mb-4">
        <i class="dot"></i>안전인력 운용현황
      </h5>
      <table-custom
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        :title="'<span style=\'font-size: 16px;font-weight: 400;\'>- 인력운용 총괄</span>'"
        :title-type="'html'"
        :controls="false"
        :multiple="false"
        :tableData="[
          { id: 'cell1', title: '확보인원', type: 'number', placeholder: '숫자입력', width: '188px' },
          { id: 'cell2', title: '주요업무', type: 'text', placeholder: '실제 시설에서 수행하는 업무를 구체적으로 기재', style: {alignText: 'left'} },
          { id: 'cell3', title: '추가필요인력', type: 'number', placeholder: '숫자입력', width: '188px' },
          { id: 'cell4', title: '사유 및 추가확보 계획', type: 'text', placeholder: '소관시설물 증가에 따른 안전점검 업무증가로 조직 및 인사부서와 협의'},
        ]"
        v-model="form.안전인력_운용현황"
      />
      <div style='font-size: 16px;font-weight: 400; margin-bottom: 14px;'>- 업무분장 반영 여부</div>
      <div class="grid pb-2 gap-2">
        <vs-radio v-model="form.업무분장_반영여부" :disabled="board.readonly" vs-name="안전인력_운용현황.업무분장_반영여부" vs-value="업무분장 반영">업무분장 반영</vs-radio>
        <div class="flex gap-2 items-center">
          <vs-radio v-model="form.업무분장_반영여부" :disabled="board.readonly" vs-name="안전인력_운용현황.업무분장_반영여부" vs-value="업무분장 미 반영">업무분장 미 반영</vs-radio>
          <ml-input v-model="form.업무분장_반영여부_input" :disabled="form.업무분장_반영여부 === '업무분장 반영'"></ml-input>
          <span>※(예시)00월까지 반영</span>
        </div>
      </div>
    </div>

    <div class="mt-28px" v-show="form.type1Checked.includes('안전점검 및 보수보강 등 유지관리 현황')">
      <h5 class="mb-4"><i class="dot"></i>안전점검 및 보수보강 등 유지관리 현황 <span style='font-size: 14px; color:#7E72F2;'>※ 대상자를 위탁운영하고 있을 경우</span>
      </h5>
      <table-custom
          class="pt-0"
          :board="board"
          :is-print="isPrint"
          :title="'<span style=\'font-size: 16px;font-weight: 400;\'>- 정기점검</span>'"
          :title-type="'html'"
          :tableData="[
        { id: 'cell1', title: '관련법령', type: 'text', placeholder: '시설물안전법 제11조' },
        { id: 'cell2', title: '분야', type: 'text', placeholder: '건축정기안전점검' },
        { id: 'cell3', title: '점검(예정)일자', type: 'text', placeholder: '입력' },
        { id: 'cell4', title: '점검내용', type: 'text', placeholder: '건축물 구조, 균열 점검' },
        { id: 'cell5', title: '점검방법(금액)', type: 'text', placeholder: '자체/용역(예산00백만원)' },
      ]"
          v-model="form.유지관리_현황_정기점검"
      />
      <table-custom
          class="pt-0"
          :board="board"
          :is-print="isPrint"
          :title="'<span style=\'font-size: 16px;font-weight: 400;\'>- 수시점검(유지관리)</span>'"
          :title-type="'html'"
          :tableData="[
        { id: 'cell1', title: '관련법령', type: 'text', placeholder: '승강기안전관리법 제31조' },
        { id: 'cell2', title: '분야', type: 'text', placeholder: '승강기유지관리' },
        { id: 'cell3', title: '주기', type: 'text', placeholder: '월1회' },
        { id: 'cell4', title: '유지관리사항', type: 'text', placeholder: '승강기 수리 부품교체 등' },
      ]"
          v-model="form.유지관리_현황_수시점검"
      />
    </div>

    <table-custom
        v-show="form.type1Checked.includes('주요 유해위험 요인 발생 및 조치현황')"
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        title="주요 유해위험 요인 발생 및 조치현황"
        :tableData="[
          { id: 'cell1', title: '발생현황', type: 'text', placeholder: '00건물 난관파손' },
          { id: 'cell2', title: '확인경위', type: 'text', placeholder: '신고/점검', width: '188px' },
          { id: 'cell3', title: '조치사항', type: 'text', placeholder: '00~00까지 이용제한, 보수보강 공사진행(00천원)' },
          { id: 'cell4', title: '보고<br>(시장)', titleType: 'html', type: 'text', placeholder: '여/부', width: '188px' },
        ]"
        v-model="form.주요유해위험요인발생및조치현황"
    />

    <table-custom
        v-show="form.type1Checked.includes('비상대피훈련 실시')"
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        :title="'<i class=\'dot\'></i>비상대피훈련 실시 <span style=\'font-size: 14px; color:#7E72F2;\'>※ 1종 시설에 해당됨</span>'"
        :title-type="'html'"
        :tableData="[
          { id: 'cell1', title: '대상법령', type: 'text', placeholder: '중처법 시행령제10조 제7호' },
          { id: 'cell2', title: '시행여부', type: 'text', placeholder: '여/부(.00.00시행)', width: '188px' },
          { id: 'cell3', title: '조치계획', type: 'text', placeholder: '00.00월 까지 시행예정' },
        ]"
        v-model="form.비상대피훈련실시"
    />

    <table-custom
        v-show="form.type1Checked.includes('관계법령의 의무사항 이행현황')"
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        :title="'<i class=\'dot\'></i>관계법령의 의무사항 이행현황 <span style=\'font-size: 14px; color:#7E72F2;\'>※ 안전점검 기재 제외</span>'"
        :title-type="'html'"
        :tableData="[
          { id: 'cell1', title: '의무사항', type: 'text', placeholder: '전기안전관리법제11조에 따른 자가용전기설비 정기 검사, 전기안전관리법 제22조 전기안전관리자 선임 등' },
          { id: 'cell2', title: '이행여부', type: 'text', placeholder: '여/부', width: '188px' },
          { id: 'cell3', title: '개선계획', type: 'text', placeholder: '00.00까지 선임예정', width: '376px' },
        ]"
        v-model="form.관계법령의의무사항이행현황"
    />

    <table-custom
        v-show="form.type1Checked.includes('교육 이수현황')"
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        :title="'<div class=\'flex items-center\'><i class=\'dot\'></i>교육 이수현황 <span class=\'ml-auto\'>[단위: 명]</span></div>'"
        :title-type="'html'"
        :tableData="[
          { id: 'target', title: '교육대상', type: 'text', placeholder: '소방안전관리자, 위험물관리자 등' },
          { id: 'take', title: '이수여부', type: 'radio', middle: true, radioItems: [{ value: '이수' }, { value: '미이수' }], width: '150px', },
          { id: 'plan', title: '이수일/이수계획', type: 'date', placeholder: '날짜선택' },
          { id: 'reason', title: '미이수 사유', type: 'customType', },
          { id: 'note', title: '비고', type: 'text', placeholder: '00.00까지 선임예정' },
        ]"
        v-model="form.교육이수현황"
    >
      <template #customType="{ trData, value, input }">
        <input v-if="!!trData && !!trData.take && trData.take === '미이수'" :readonly="board.readonly"
               class="w-full flex-1" :value="value" @input="(e) => input(e.target.value)"
               placeholder="위험물관리자 변경(선임 6개월이내 이수)" />
      </template>
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td v-if="!isPrint" class="border-none"></td>
          <td style="padding: 10px 15px;" colspan="5" class="border-none">
            <div class="flex" style="place-content: center;">
              <div class="mx-10" style="align-self: center;">합계</div>
              <comma-input readonly placeholder="자동입력" v-model="form.takeSum" />
              <div class="mx-10" style="align-self: center;">이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.taken" />
              <div class="mx-10" style="align-self: center;">미이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.untaken" />
            </div>
          </td>
        </tr>
      </template>
    </table-custom>

    <table-custom
        v-show="form.type2Checked.includes('의무사항 미이행 현황')"
        class="mt-28px"
        :board="board"
        :is-print="isPrint"
        title="의무사항 미이행 현황"
        :tableData="[
          { id: 'cell1', title: '관계법령', type: 'text', placeholder: '입력' },
          { id: 'cell2', title: '의무사항', type: 'text', placeholder: '입력' },
          { id: 'cell3', title: '미조치 사유', type: 'text', placeholder: '입력' },
          { id: 'cell4', title: '이행계획', type: 'text', placeholder: '입력' },
        ]"
        v-model="form.의무사항미이행현황"
    />

    <div class="mt-28px" v-show="form.type2Checked.includes('사고발생 현황')">
      <div class="flex justify-between">
        <h5 class="mb-4"><i class="dot"></i>사고발생 현황</h5>
        <span>[단위: 명]</span>
      </div>
      <table class="mb-4">
        <tbody>
        <tr>
          <th>구분-피해현황</th>
          <th style="border-right: none;">피해인원</th>
          <th style="border-left: none; border-right: none;">사고경위 및 조치</th>
          <th style="border-left: none; border-right: none;">비고</th>
        </tr>
        <tr v-for="cell in form.사고발생현황">
          <th>{{ cell.cell1 }}</th>
          <td style="border-right: none;">
            <p v-if="isPrint">{{ cell.cell2 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell2" :readonly="cell.cell1 === '계'" type="number"
                      :min-value="0" />
          </td>
          <td style="border-left: none; border-right: none;">
            <p v-if="isPrint">{{ cell.cell3 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell3" />
          </td>
          <td style="border-left: none; border-right: none;">
            <p v-if="isPrint">{{ cell.cell4 }}</p>
            <ml-input v-else class="w-full" v-model="cell.cell4" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-28px" v-show="form.type2Checked.includes('기타 개선 및 보완이 필요한 사항')">
      <h5 class="mb-2"><i class="dot"></i>기타 개선 및 보완이 필요한 사항</h5>
      <div class="mb-2">- 점검결과(총평)</div>
      <div class="w-full">
        <p v-if="isPrint">
          {{ form.기타개선및보완이필요한사항 }}
        </p>
        <ml-textarea class="m-0" :readonly="board.readonly" v-else rows="5" v-model="form.기타개선및보완이필요한사항"
                     placeholder="※ 보완해야 할 내용, 미흡·부족 사항 보완시기
※ 기타: 문제점·애로사항 및 재도개선·발전방안 건의 등"/>
      </div>
    </div>

<!--    의무이행사항 점검결과(원료/제조물) 체크시 -->
<!--    <TableInspectMerge-->
<!--        v-for="(item, itemIndex) in form.inspectList"-->
<!--        :key="`inspect1_${item.title}_${itemIndex}`"-->
<!--        v-show="form.inspectChecked.includes(item.title) && item.title === '의무이행사항 점검결과(원료/제조물)'"-->
<!--        :is-print="isPrint"-->
<!--        :is-readonly="board.readonly"-->
<!--        :title="item.title"-->
<!--        :is-title-dot="item.isTitleDot"-->
<!--        :tableHeaderTitle="item.tableHeaderTitle || '중대재해처벌법 의무이행 사항'"-->
<!--        :tableHeaderCheck="item.tableHeaderCheck"-->
<!--        :tableHeaderNote="item.tableHeaderNote"-->
<!--        :footer="item.footer"-->
<!--        v-model="item.list"-->
<!--        class="mt-28px"-->
<!--    />-->

<!--    의무이행사항 점검결과(공중이용시설 직접관리 시설) 체크시-->
<!--    <TableInspectMerge-->
<!--        v-for="(item, itemIndex) in form.inspectList"-->
<!--        :key="`inspect2_${item.title}_${itemIndex}`"-->
<!--        v-show="form.inspectChecked.includes(item.title) && item.title === '의무이행사항 점검결과(공중이용시설 직접관리 시설)'"-->
<!--        :is-print="isPrint"-->
<!--        :is-readonly="board.readonly"-->
<!--        :title="item.title"-->
<!--        :is-title-dot="item.isTitleDot"-->
<!--        :tableHeaderTitle="item.tableHeaderTitle || '중대재해처벌법 의무이행 사항'"-->
<!--        :tableHeaderCheck="item.tableHeaderCheck"-->
<!--        :tableHeaderNote="item.tableHeaderNote"-->
<!--        :footer="item.footer"-->
<!--        v-model="item.list"-->
<!--        class="mt-28px"-->
<!--        @click="onClickInspectList"-->
<!--    />-->

<!--    의무이행사항 점검결과(공중이용시설 위탁운영 시설) 체크시-->
<!--    <h5 v-if="form.inspectChecked.includes('의무이행사항 점검결과(공중이용시설 위탁운영 시설)')" class="mt-28px"><i class="dot"></i>의무이행사항 점검결과(위탁운영-->
<!--      시설)</h5>-->
<!--    <TableInspectMerge-->
<!--        v-for="(item, itemIndex) in form.inspectList"-->
<!--        :key="`inspect3_${item.title}_${itemIndex}`"-->
<!--        v-show="form.inspectChecked.includes(item.title) && item.title === '의무이행사항 점검결과(공중이용시설 위탁운영 시설)'"-->
<!--        :is-print="isPrint"-->
<!--        :is-readonly="board.readonly"-->
<!--        :title="item.subTitle"-->
<!--        :is-title-dot="item.isTitleDot"-->
<!--        :tableHeaderTitle="item.tableHeaderTitle || '중대재해처벌법 의무이행 사항'"-->
<!--        :tableHeaderCheck="item.tableHeaderCheck"-->
<!--        :tableHeaderNote="item.tableHeaderNote"-->
<!--        :footer="item.footer"-->
<!--        v-model="item.list"-->
<!--        class="mt-3"-->
<!--        @click="onClickInspectList"-->
<!--    />-->

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelectorMultiple from "@/components/selector/FieldSelectorMultiple.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import inspectData from "@/views/boards/single-page/1044/inspectData";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    RadioGroup,
    PrintRadio,
    TableInspectMerge,
    TableCustom,
    DateSelectorRang,
    FieldSelector,
    FieldSelectorMultiple,
    DateSelector,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    getTitles() {
      const titleSet = new Set(this.form.inspectList.map((item) => item.title));
      return Array.from(titleSet);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
    },
    boardId() {
      return this.$route.params.boardId;
    },
    소관부서() {
      if (this.form.fields && this.form.fields.length > 0) {
        const 소관부서 = this.form.fields.map((item) => {
          const meta = item.meta ? JSON.parse(item.meta) : {};
          return meta.소관부서;
        });
        return [...new Set(소관부서)].join(', ')
      }
      return ""
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.교육이수현황": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length !== 0) {
          this.form.taken = 0
          this.form.untaken = 0
          for(const item of this.form.교육이수현황) {
            if (item.take === '이수') {
              this.form.taken += 1
            } else if (item.take === '미이수') {
              this.form.untaken += 1
            }
          }
          this.form.takeSum = this.form.taken + this.form.untaken
        }
      },
    },

    "form.사고발생현황": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length !== 0) {
          let sum = 0;
          for (const item of value) {
            if (item.cell1 !== "계") {
              sum += Number(item.cell2);
            }
          }
          value[value.length - 1].cell2 = sum;
        }
      },
    },
  },
  data() {
    return {
      type1Title: ["안전예산 집행내역", "안전인력 운용현황", "안전점검 및 보수보강 등 유지관리 현황", "주요 유해위험 요인 발생 및 조치현황", "비상대피훈련 실시", "관계법령의 의무사항 이행현황", "교육 이수현황"],
      type2Title: ["의무사항 미이행 현황", "사고발생 현황", "기타 개선 및 보완이 필요한 사항"],
      EnableSave: false,
      editIndex: undefined,
      editData: undefined,
      form: {
        stdInfo: {},
        fields: [], // 시설명
        점검기간: { sDate: "", eDate: "" },
        점검내용: "",
        총평: "",

        type1Checked: [],
        type2Checked: [],

        // 안전예산 집행내역
        year: new Date().getFullYear(),
        구분: "상반기",

        집행내역: {
          안전점검: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          보수보강: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          안전조치: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          인건비: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          기타: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
        },
        합계: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },

        추가소요액확보계획: "",
        // 안전인력 운용현황
        안전인력_운용현황: [{ cell1: '', cell2: '', cell3: '', cell4: '' }],
        업무분장_반영여부: "",
        업무분장_반영여부_input: "",
        // 안전점검 및 보수보강 등 유지관리 현황
        유지관리_현황_정기점검: [],
        유지관리_현황_수시점검: [],
        주요유해위험요인발생및조치현황: [],
        비상대피훈련실시: [],
        관계법령의의무사항이행현황: [],
        교육이수현황: [],

        의무사항미이행현황: [],
        사고발생현황: [
          { cell1: '사망자', cell2: '', cell3: '', cell4: '' },
          { cell1: '부상자', cell2: '', cell3: '', cell4: '' },
          { cell1: '질병자', cell2: '', cell3: '', cell4: '' },
          { cell1: '계', cell2: '', cell3: '', cell4: '' },
        ],
        기타개선및보완이필요한사항: "",

        taken: 0,
        untaken: 0,
        takeSum: 0,

        inspectionTitle: "",
        inspectChecked: [],
        inspectList: inspectData,

        fileList: [],
      }
    };
  },
  methods: {

    async loadListBoard() {
      if (!this.form.stdInfo.field_id) return;

      // 기존에 로드한 데이터가 있으면 그냥 사용
      if (this.oldForm[`${this.form.year}_${this.form.구분}`]) {
        this.EnableSave = false;
        this.form = { ...this.form, 집행내역: this.oldForm[`${this.form.year}_${this.form.구분}`] };
        return;
      } else {
        this.EnableSave = true;
        this.form.집행내역 = {
          안전점검: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          보수보강: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          안전조치: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          인건비: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
          기타: { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 },
        };
        this.form.합계 = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
      }

      const params = {
        projectId: this.projectId,
        page: 1,
        fieldId: this.form.stdInfo.field_id,
      };

      const conditions = [
        {
          key: "body.year",
          operator: "=",
          value: `${this.form.year}`,
        },
        {
          key: "body.구분",
          operator: "=",
          value: this.form.구분,
        },
      ];

      for (let i = 0, condition; (condition = conditions[i]); i++) {
        const keys = Object.keys(condition);
        for (const key of keys) {
          params[`conditions[${i}][${key}]`] = condition[key];
        }
      }

      HttpRequest.get(`/api/v1/board/post/${this.boardId}`, { params })
          .then((response) => {
            if (response.data.length < 1) {
              this.EnableSave = true;
            } else {
              this.EnableSave = false;

              const data = this.getContent(response.data[0]);
              if (data.집행내역) {
                const keys = Object.keys(data.집행내역);
                if (keys.indexOf("기타") === -1) {
                  data.집행내역["기타"] = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
                }
              }

              this.oldForm = { ...this.oldForm, [`${this.form.year}_${this.form.구분}`]: data.집행내역 };
              this.form.집행내역 = data.집행내역;
            }
          })
          .catch((err) => {
          });
    },
    inputNumber(key) {
      this.form.집행내역[key].잔액 = this.form.집행내역[key].편성액 - this.form.집행내역[key].집행액;
      if (this.form.집행내역[key].편성액 && this.form.집행내역[key].집행액) this.form.집행내역[key].집행률 = ((this.form.집행내역[key].집행액 * 100) / this.form.집행내역[key].편성액).toFixed(2);
      else this.form.집행내역[key].집행률 = 0.0;

      const 합계 = { 편성액: 0, 집행액: 0, 잔액: 0, 추가소요액: 0, 집행률: 0 };
      for (const key in this.form.집행내역) {
        합계.편성액 += Number(this.form.집행내역[key].편성액);
        합계.집행액 += Number(this.form.집행내역[key].집행액);
        합계.잔액 += Number(this.form.집행내역[key].잔액);
        합계.추가소요액 += Number(this.form.집행내역[key].추가소요액);
      }
      if (합계.편성액 && 합계.집행액) 합계.집행률 = ((합계.집행액 * 100) / 합계.편성액).toFixed(2);
      else 합계.집행률 = 0.0;
      this.form.합계 = 합계;
    },
    selectFields (fields) {
      if (this.form.fields && this.form.fields.length > 0) {
        this.form.fields = this.form.fields.map((item) => {
          const meta = item.meta ? JSON.parse(item.meta) : {};

          if (!item.관리형태) {
            item.관리형태 = meta.관리방법 || '-';
          }

          if (!item.시설종류) {
            item.시설종류 = `${meta.cat1 || '-'} > ${meta.cat2 || '-'} > ${meta.cat3 || '-'} > ${meta.classification || '-'}`;
          }

          return {
            ...item,
            "규모": "",
            "대상법령": "",
            "위탁부서": "",
            "위탁기간": { "sDate": "", "eDate": ""},
            "수탁기관명": "",
            "수탁비용": "",
          };
        });
      }
    },
    onClickEditData(index) {
      this.editIndex = index;
      this.editData = JSON.parse(JSON.stringify(this.form.fields[index]));
    },
    onClickRemoveData(index) {
      this.form.fields.splice(index, 1);
    },
    onClickFinishData(index) {
      this.form.fields[index] = this.editData;
      this.editIndex = null;
      this.editData = null;
    },
    onClickCancelData(index) {
      this.editIndex = null;
      this.editData = null;
    },

    onClickInspectList (key, value) {
      if (key === "유해·위험요인 점검") {
        const popup = window.open(`/project/${this.projectId}/tab/613`, '_blank', `width=${  screen.width  },height=${  screen.height}`);
      }
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
input {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0.7rem !important;
  transition: all 0.3s ease;
  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
  }

  th {
    height: 50px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    background-color: #f9f9f9;
  }
}
.icon-buttons {
  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }
}
</style>
